import scenes from '../scenes'
import * as overlayStyle from 'constants/overlayStyles'
import * as customFieldTypes from 'constants/customFieldTypes'
import * as sidebarSceneType from 'constants/sidebarSceneType'
import * as stylePresetType from 'constants/stylePresetType'

const customFields = [
  {
    id: 'preload',
    location: { scene: scenes[1] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene1', 'logo' ],
      isSmall: true,
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene1', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo`,
            presetType: stylePresetType.AROUND
          },
          { className: 'aw_splash__logo', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene1', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__title',
        stylePresets: [
          {
            title: 'Title position:',
            className: `aw_splash__title`,
            presetType: stylePresetType.POSITION
          },
          {
            title: 'Text color:',
            className: 'aw_splash__title',
            presetType: stylePresetType.COLOR,
            options: ['#e4c37f', 'black', 'white']
          },
          { title: 'Text effects:', className: `aw_splash__title`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_splash__title`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_splash__title', presetType: stylePresetType.HIDDEN },
        ]
      }
    ]
  },
  {
    id: 'intro',
    location: { scene: scenes[2] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene2', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene2', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_curtains__bg',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `aw_curtains__bg`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene2', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-2',
        customStyle: '.aw_splash__logo-2 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-2`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-2`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-2`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-2`,
              `aw_splash__logo-3`,
              `aw_splash__logo-4`,
              `aw_splash__logo-5`,
              `aw_splash__logo-6`,
              `aw_splash__logo-7`,
              `aw_splash__logo-8`
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-2`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'callout1',
        type: customFieldTypes.TEXT,
        name: 'Edit Callout Line 1',
        paths: [[ 'scene2', 'text1' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_curtains__text1',
        stylePresets: [
          {
            title: 'Pan:',
            className: `aw_curtains__text--1`,
            presetType: stylePresetType.POSITION
          },
          {
            title: 'Text color:',
            className: 'aw_curtains__text--1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_curtains__text--1`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_curtains__text--1`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_curtains__text--1', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'callout2',
        type: customFieldTypes.TEXT,
        name: 'Edit Callout Line 2',
        paths: [[ 'scene2', 'text2' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_curtains__text2',
        stylePresets: [
          {
            title: 'Pan:',
            className: `aw_curtains__text--2`,
            presetType: stylePresetType.POSITION
          },
          {
            title: 'Text color:',
            className: 'aw_curtains__text--2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_curtains__text--2`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_curtains__text--2`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_curtains__text--2', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'videoScene',
    location: { scene: scenes[3] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene3', 'video', 'thumbUrl' ],
    },
    fields: [
      {
        id: 'video',
        type: customFieldTypes.VIDEO,
        name: 'Assign Video',
        paths: [[ 'scene3', 'video' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_video__video'
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene3', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-3',
        customStyle: '.aw_splash__logo-3 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-3`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-3`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-3`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-3`,
              `aw_splash__logo-2`,
              `aw_splash__logo-4`,
              `aw_splash__logo-5`,
              `aw_splash__logo-6`,
              `aw_splash__logo-7`,
              `aw_splash__logo-8`
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-3`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene3', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_video__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_video__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_video__title`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_video__title`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_video__title', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'desc',
        type: customFieldTypes.TEXT,
        name: 'Edit Description',
        paths: [[ 'scene3', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_video__description',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_video__description',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_video__description`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_video__description--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_video__description', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'button',
        type: customFieldTypes.ACTION_BUTTON_W_DESIGN,
        name: 'Edit Button',
        paths: [[ 'scene3', 'button' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_video__button',
        stylePresets: [
          {
            title: 'Text&Border color:',
            className: 'aw_video__button',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_video__button`, presetType: stylePresetType.TEXT_EFFECT },
        ]
      }
    ]
  },
  {
    id: 'slide1',
    location: { scene: scenes[4] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene4', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene4', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_slide__bg_1',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `aw_slide__bg_1`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene4', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-4',
        customStyle: '.aw_splash__logo-4 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-4`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-4`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-4`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-4`,
              `aw_splash__logo-2`,
              `aw_splash__logo-3`,
              `aw_splash__logo-5`,
              `aw_splash__logo-6`,
              `aw_splash__logo-7`,
              `aw_splash__logo-8`
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-4`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene4', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__title_1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__title_1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__title_1`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__title_1`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__title_1', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene4', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__desc_1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__desc_1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__desc_1`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__desc_1--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__desc_1', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'tip',
        type: customFieldTypes.TEXT,
        name: 'Edit Tip',
        paths: [[ 'scene4', 'tip' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__tip_1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__tip_1`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__tip_1--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__tip_1', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Tip Icon',
        paths: [[ 'scene4', 'tipIcon' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip-icon_1',
        stylePresets: [
          {
            title: 'Add background around image:',
            className: `aw_slide__tip-icon_1`,
            presetType: stylePresetType.AROUND
          },
        ]
      },
      {
        id: 'tipButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene4', 'appLinks', 'google' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_1--button-1',
        stylePresets: [
          {
            className: 'aw_slide__tip_1--button-1',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'tipButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene4', 'appLinks', 'apple' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_1--button-2',
        stylePresets: [
          {
            className: 'aw_slide__tip_1--button-2',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
    ]
  },
  {
    id: 'slide2',
    location: { scene: scenes[5] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene5', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene5', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_slide__bg_2',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `aw_slide__bg_2`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene5', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-5',
        customStyle: '.aw_splash__logo-5 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-5`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-5`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-5`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-5`,
              `aw_splash__logo-2`,
              `aw_splash__logo-3`,
              `aw_splash__logo-4`,
              `aw_splash__logo-6`,
              `aw_splash__logo-7`,
              `aw_splash__logo-8`
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-5`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene5', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__title_2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__title_2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__title_2`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__title_2`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__title_2', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene5', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__desc_2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__desc_2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__desc_2`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__desc_2--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__desc_2', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'tip',
        type: customFieldTypes.TEXT,
        name: 'Edit Tip',
        paths: [[ 'scene5', 'tip' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__tip_2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__tip_2`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__tip_2--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__tip_2', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Tip Icon',
        paths: [[ 'scene5', 'tipIcon' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip-icon_2',
        stylePresets: [
          {
            title: 'Add background around image:',
            className: `aw_slide__tip-icon_2`,
            presetType: stylePresetType.AROUND
          },
        ]
      },
      {
        id: 'tipButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene5', 'appLinks', 'google' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_2--button-1',
        stylePresets: [
          {
            className: 'aw_slide__tip_2--button-1',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'tipButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene5', 'appLinks', 'apple' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_2--button-2',
        stylePresets: [
          {
            className: 'aw_slide__tip_2--button-2',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
    ]
  },
  {
    id: 'slide3',
    location: { scene: scenes[6] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene6', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene6', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_slide__bg_3',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `aw_slide__bg_3`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene6', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-6',
        customStyle: '.aw_splash__logo-6 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-6`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-6`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-6`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-6`,
              `aw_splash__logo-2`,
              `aw_splash__logo-3`,
              `aw_splash__logo-4`,
              `aw_splash__logo-5`,
              `aw_splash__logo-7`,
              `aw_splash__logo-8`
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-6`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene6', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__title_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__title_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__title_3`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__title_3`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__title_3', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene6', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__desc_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__desc_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__desc_3`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__desc_3--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__desc_3', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'tip',
        type: customFieldTypes.TEXT,
        name: 'Edit Tip',
        paths: [[ 'scene6', 'tip' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_slide__tip_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_slide__tip_3`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_slide__tip_3--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_slide__tip_3', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Tip Icon',
        paths: [[ 'scene6', 'tipIcon' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip-icon_3',
        stylePresets: [
          {
            title: 'Add background around image:',
            className: `aw_slide__tip-icon_3`,
            presetType: stylePresetType.AROUND
          },
        ]
      },
      {
        id: 'tipButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene6', 'appLinks', 'google' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_3--button-1',
        stylePresets: [
          {
            className: 'aw_slide__tip_3--button-1',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'tipButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene6', 'appLinks', 'apple' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip_3--button-2',
        stylePresets: [
          {
            className: 'aw_slide__tip_3--button-2',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
    ]
  },
  {
    id: 'slide4',
    location: { scene: scenes[7] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene7', 'bg' ],
    },
    fields: [
      {
        id: 'title',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene7', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_featured__bg',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `aw_featured__bg`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene7', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-7',
        customStyle: '.aw_splash__logo-7 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-7`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-7`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-7`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-7`,
              `aw_splash__logo-2`,
              `aw_splash__logo-3`,
              `aw_splash__logo-4`,
              `aw_splash__logo-5`,
              `aw_splash__logo-6`,
              `aw_splash__logo-8`
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-7`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Featured Image',
        paths: [[ 'scene7', 'img' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_featured__img',
        stylePresets: [
          { className: 'aw_featured__img', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'tip',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene7', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_featured__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_featured__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_featured__title`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_featured__title`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_featured__title', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Tip Icon',
        paths: [[ 'scene7', 'tipIcon' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_slide__tip-icon_4',
        stylePresets: [
          {
            title: 'Add background around image:',
            className: `aw_slide__tip-icon_4`,
            presetType: stylePresetType.AROUND
          },
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene7', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_featured__description',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_featured__description',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_featured__description`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_featured__description--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_featured__description', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'lastScene',
    location: { scene: scenes[8], shareButtonsVisible: 0 },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene8', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene8', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'aw_last__bg',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `aw_last__bg`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene8', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_splash__logo-8',
        customStyle: '.aw_splash__logo-8 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `aw_splash__logo-8`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `aw_splash__logo-8`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `aw_splash__logo-8`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `aw_splash__logo-8`,
              `aw_splash__logo-2`,
              `aw_splash__logo-3`,
              `aw_splash__logo-4`,
              `aw_splash__logo-5`,
              `aw_splash__logo-6`,
              `aw_splash__logo-7`,
            ],
            getSlideClassName: num => `aw_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: `aw_splash__logo-8`, presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene8', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_last__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_last__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_last__title`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_last__title`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_last__title', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'desc',
        type: customFieldTypes.TEXT,
        name: 'Edit Description',
        paths: [[ 'scene8', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_last__description',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_last__description',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_last__description`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `aw_last__description--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'aw_last__description', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'button',
        type: customFieldTypes.CUSTOM_BUTTON_W_URL,
        name: 'Edit Button',
        paths: [[ 'scene8', 'button' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_last__button',
        stylePresets: [
          { className: 'aw_last__button', presetType: stylePresetType.HIDDEN }
        ],
        related: {
          url: [ 'scene8', 'buttonUrl' ]
        }
      },
      {
        id: 'buttonUrl',
        type: customFieldTypes.TEXT,
        name: 'Edit Button URL',
        paths: [[ 'scene8', 'buttonUrl' ]],
        overlayStyle: overlayStyle.GreenField
      },
      {
        id: 'appButtonsContainer',
        type: customFieldTypes.BUTTONS_CONTAINER,
        paths: [[ 'scene8', 'appButtonsContainer' ]],
        name: 'Buttons Container',
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_last__applinks-container'
      },
      {
        id: 'appButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene8', 'appLinks', 'google' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_last__applinks--button-1',
        stylePresets: [
          {
            className: 'aw_last__applinks--button-1',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'appButton',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        paths: [[ 'scene8', 'appLinks', 'apple' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_last__applinks--button-2',
        stylePresets: [
          {
            className: 'aw_last__applinks--button-2',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'shareButton',
        type: customFieldTypes.SHARE_BUTTON,
        name: 'Edit share button',
        paths: [[ 'lastScene', 'shareButton' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__main-button',
        stylePresets: [
          {
            className: 'aw_share__main-button', presetType: stylePresetType.HIDDEN
          }
        ]
      }
    ]
  },
  {
    id: 'lastSceneShare',
    location: { scene: scenes[8], shareButtonsVisible: 1 },
    siderbarPreview: { type: sidebarSceneType.HIDDEN },
    fields: [
      {
        id: 'shareTitle',
        type: customFieldTypes.TEXT,
        name: 'Edit share title',
        paths: [[ 'scene8', 'shareTitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_share__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_share__title`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'aw_share__title', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'shareSubtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit share subtitle',
        paths: [[ 'scene8', 'shareSubtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__subtitle',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_share__subtitle',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_share__subtitle`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'aw_share__subtitle', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'fb',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Facebook',
        paths: [[ 'scene8', 'facebook' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__button--facebook',
        stylePresets: [
          {
            className: 'aw_share__button--facebook',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'twitter',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Twitter',
        paths: [[ 'scene8', 'twitter' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__button--twitter',
        stylePresets: [
          {
            className: 'aw_share__button--twitter',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'email',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Email',
        paths: [[ 'scene8', 'email' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__button--email',
        stylePresets: [
          {
            className: 'aw_share__button--email',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'phone',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Phone',
        paths: [[ 'scene8', 'phone' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__button--sms',
        stylePresets: [
          {
            className: 'aw_share__button--sms',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'shareSubtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit subtitle',
        paths: [[ 'scene8', 'shareSubtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__subtitle',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_share__subtitle',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_share__subtitle`, presetType: stylePresetType.TEXT_EFFECT },
          {
            className: 'aw_share__subtitle', presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'shareTitle',
        type: customFieldTypes.TEXT,
        name: 'Edit title',
        paths: [[ 'scene8', 'shareTitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'aw_share__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'aw_share__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `aw_share__title`, presetType: stylePresetType.TEXT_EFFECT },
          {
            className: 'aw_share__title', presetType: stylePresetType.HIDDEN
          }
        ]
      }
    ]
  }
]

export default customFields



// WEBPACK FOOTER //
// ./src/templates/app-website/template/customFields.js